import { makeStyles } from 'makeStyles';
import { CANCEL_RED } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  TMXDialog: {
    borderRadius: '3px',
    padding: theme.spacing(2),
  },
  TMXDialogTitle: {
    padding: 0,
  },
  TMXDialogContent: {
    padding: 0,
  },
  TMXDialogActions: {
    padding: 0,
  },
  cancelButton: {
    color: CANCEL_RED,
  },
  deleteDrawDialogContent: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 15,
    marginBottom: '1em',
  },
  deleteDrawDialogNote: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 15,
    marginTop: '1em',
    marginBottom: '1em',
  },
  paper: { padding: 40, boxShadow: '0 10px 25px 0 rgba(0, 0, 0, 0.12)' },
  actionsContainer: {
    marginTop: 24,
    padding: '8px 0',
  },
  selectedPlayer: {
    fontSize: 15,
    letterSpacing: 'normal',
    textAlign: 'center',
    fontWeight: 900,
    color: '#169e8f',
  },
}));
